import React, { useMemo } from "react";

import { useNeighborhoodHighlights } from "~/sdks/NeighborhoodHighlights/context";
import { useTranslation } from "react-i18next";
import type { Scores } from "@local-logic/client";

import { LoadingSpinner } from "@local-logic/core/ui";

import { includeScores } from "~/sdks/NeighborhoodHighlights/constants";
import { NoDataContent } from "~/components/NoDataContent";
import * as Highlights from "../Highlights";

import * as styles from "./styles";

export function Content() {
  const { t } = useTranslation("neighborhoodHighlights");
  const { isLoading, scores } = useNeighborhoodHighlights();

  const highlights = useMemo(() => {
    if (isLoading) {
      return [];
    }

    const highlightKeys: (keyof Scores["location"])[] = [];

    if (scores) {
      const filteredScores = includeScores
        .map((scoreName) => ({
          scoreName,
          value: (Math.round(Number(scores[scoreName]?.value) * 10) / 10) * 2,
        }))
        .filter((score) => score.value > 7)
        .sort((a, b) => (a.value < b.value ? 1 : -1))
        .slice(0, 3);

      filteredScores.map((item) => highlightKeys.push(item.scoreName));
    }

    return highlightKeys;
  }, [scores, isLoading]);

  if (isLoading) {
    return (
      <div className={styles.loadingContent}>
        <LoadingSpinner image />
      </div>
    );
  }

  return (
    <>
      {highlights.length > 0 ? (
        <Highlights.Root>
          {highlights.map((highlight) => (
            <div key={`highlight-${highlight}`} className={styles.highlight}>
              <Highlights.Item score={highlight} />
            </div>
          ))}
        </Highlights.Root>
      ) : (
        <NoDataContent text={t("noData")} />
      )}
    </>
  );
}
